import React from "react";
import {useTranslation} from "react-i18next";

type Props = {
    show: boolean;
};

const NetworkToast = ({show}: Props) => {
    const {t} = useTranslation();

    if (!show) return null;

    const message = !navigator.onLine
        ? t("constraints.internal.no_internet_connection")
        : t("constraints.internal.loading_data_error");

    return (
        <div className="network-alert alert alert-danger">
            {message}
        </div>
    );
};

export default NetworkToast;